import hasTrialProRole, {
  hasPatientRole,
} from '@modules/auth/helpers/hasTrialProRole'
import decodeJwt from '@modules/auth/jwt/decodeJwt'
import getJwtCookie from '@modules/auth/jwt/getJwtCookie'
import type { UserJwtPayload } from '@modules/auth/jwt/types'
import type { Role } from '@prisma/client'

export function useUserRoles() {
  const jwt = getJwtCookie()
  const decodedJwt = jwt ? decodeJwt<UserJwtPayload>(jwt) : undefined
  const decodedRoles = decodedJwt ? decodedJwt.roles : []
  const roles = decodedRoles.map((role) => role.type as Role)

  return {
    isPatient: hasPatientRole(roles),
    isTrialPro: hasTrialProRole(roles),
    userRoles: roles,
  }
}
